import { CardView } from "@/client/components/card-view";
import { type CreditCard } from "@/data/schemas";
import { SimpleGrid } from "@mantine/core";

export const CardListView = ({ cards }: { cards: CreditCard[] }) => {
  return (
    <SimpleGrid spacing="xl" cols={{ base: 1, xl: 2 }}>
      {cards
        .filter((c) => !c.discontinued)
        .map((card) => (
          <CardView key={card.issuer + card.name} card={card} />
        ))}
    </SimpleGrid>
  );
};
